import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';

class Component extends BaseComponent {
    render({ value, action, content }) {
        return (
            <compatibility-chooser-dropdown-item
              value={value}
              onclick={action}
            >
                {content()}
            </compatibility-chooser-dropdown-item>
        );
    }
}

const mapStateToProps = () => ({
});

export default connect(mapStateToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/compatibility/item.js